import { Field, Formik, Form, ErrorMessage } from "formik";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import successToast from "../../components/toasts/successToast";
import logo from "../../assets/images/acumenVelocityLogo.svg";
import { Image, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import errorToast from "../../components/toasts/errorToast";
import { resetPasswordAction } from "../../redux/actions/authAction";
import { passwordSchema, confirmPasswordSchema } from "../../utils/passwordValidation";
import PasswordStrengthMeter from "../../components/PasswordStrengthMeter";

const ResetPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    let { token } = useParams();
    const initialValues = {
        password: '',
        confirmPassword: '',
    }

    const onSuccess = (data) => {
        successToast(data.data.message);
        navigate('/email-login');
        setLoading(false);
    }

    const onError = (data) => {
        errorToast(data.data.message);
        setLoading(false);
    }

    const validationSchema = Yup.object().shape({
        password: passwordSchema,
        confirmPassword: confirmPasswordSchema,
    });

    const onSubmit = (values) => {
        const dispatchingValues = {
            resetToken: token,
            password: values.confirmPassword,
        }
        dispatch(resetPasswordAction(dispatchingValues, onSuccess, onError))
        setLoading(true)
    }

    return (
        <div className="d-flex vh-100">
            <div className="w-100 d-flex flex-column">
                <div
                    className="d-flex align-items-center cursor_pointer p-2 m-1"
                    style={{ height: "8vh" }}
                    onClick={() => navigate("/")}
                >
                    <Image alt="logo" src={logo} height={40} className="mx-2" />
                    <p className="name fs_18 fw_600 m-0">Acumen Translation Hub</p>
                </div>
                <div className="flex-grow-1 d-flex justify-content-center align-items-center fn_Roboto">
                    <div className="bg-light border-opacity-10 border d-flex flex-column flex-md-row justify-content-center align-items-center p-4 rounded-3 mx-2 mx-md-5 gap-2 col-12 col-md-8 col-lg-5">
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={onSubmit}
                        >
                            {({ values, setFieldValue, isValid, dirty }) => (
                                <Form className=" h-100 justify-content-between">
                                    <div>
                                        <span className="fs_26 fw_600">Reset Password</span>
                                        <div className="text-start gap-3 mb-2 pt-4 text-nowrap mx-4">
                                            <label htmlFor="password" className="py-1">
                                                Password
                                            </label>
                                            <div className="d-flex position-relative">
                                                <Field
                                                    type={"password"}
                                                    name="password"
                                                    className="input-field"
                                                    id="password"
                                                    style={{ width: "20rem" }}
                                                />
                                            </div>
                                            <PasswordStrengthMeter password={values.password} />
                                            <ErrorMessage
                                                name="password"
                                                component="div"
                                                className="text-danger mt-1 fs_12"
                                            />
                                        </div>
                                        <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                            <label htmlFor="confirmPassword" className="py-1">
                                                Confirm Password
                                            </label>
                                            <div className="d-flex position-relative">
                                                <Field
                                                    type={"password"}
                                                    name="confirmPassword"
                                                    className="input-field"
                                                    id="confirmPassword"
                                                    style={{ width: "20rem" }}
                                                />
                                            </div>
                                            <ErrorMessage
                                                name="confirmPassword"
                                                component="div"
                                                className="text-danger mt-1 fs_12"
                                            />
                                        </div>
                                    </div>
                                    {loading && (
                                        <div className="d-flex align-items-center text-center">
                                            <Spinner size="sm" className="text-primary" />{" "}
                                            <span className="ms-2">Updating...</span>
                                        </div>
                                    )}
                                    <div className="d-flex justify-content-around m-4">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            style={{ width: "8rem", height: "2.5rem" }}
                                            disabled={loading}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword;
